exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._17zPQPxCoLYjzO9j328c1l .panel-body{padding:20px 10px}._17zPQPxCoLYjzO9j328c1l ul{padding-left:1em}", ""]);

// exports
exports.locals = {
	"templatePreview": "_17zPQPxCoLYjzO9j328c1l"
};